export const SYNC_FACE_ID_REQUEST = 'SYNC_FACE_ID_REQUEST' as const;
export const SYNC_FACE_ID_SUCCESS = 'SYNC_FACE_ID_SUCCESS' as const;
export const SYNC_FACE_ID_ERROR = 'SYNC_FACE_ID_ERROR' as const;
